export const enum CapaStatus {
  IN_INVESTIGATION = 'IN_INVESTIGATION',

  IN_PLANNING = 'IN_PLANNING',

  FOLLOWUP = 'FOLLOWUP',
}
